import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { AuthProvider } from '../../providers/auth/auth';
import { NavController, ModalController } from 'ionic-angular';
import { UserProvider } from '../../providers/user/user';
import { PushNotificationsProvider } from '../../providers/push-notifications/push-notifications';
import { ToolsProvider } from '../../providers/tools/tools';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { PlaceServiceProvider } from '../../providers/trip-service/place-service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'main-nav',
  templateUrl: 'main-nav.html',
})
export class MainNavComponent {
  // Notifications
  // Image
  // Title

  log = debug('app:MainNavComponent');
  @Input()
  pageTitle = '';
  @Input()
  showBackButton = false;
  @Input() showAuthorizedUser = false;
  @Input() innerContent = false;

  authenticated = false;
  userInfo;
  subs: any = [];
  pushSubscriptionOff: Function;
  notifStyle = 'single';

  notificationsPaddingRight = '16px';
  notificationsPaddingCircle = '4px 6.9px';
  notificationBorderRadius = '50%';
  notificationCircleRight = '-10px';
  userNavBlocked = false;
  showButtons = false;
  loadingTabs = false;

  constructor(
    private authService: AuthProvider,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public user: UserProvider,
    public pushNotifications: PushNotificationsProvider,
    public tools: ToolsProvider,
    public crudApiProvider: CrudApiProvider,
    public placeService: PlaceServiceProvider
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.checkAuthenticated();
    }, 0);
    this.subs.push(
      this.authService.on('authenticated', () => {
        this.checkAuthenticated();
      })
    );
  }

  // Other functions

  private checkAuthenticated() {
    this.authenticated = this.user.authenticated;
    if (this.authenticated) {
      this.userInfo = this.user.get();
    }
    if (
      this.authenticated &&
      !this.user.unauthedUser &&
      _.get(this.userInfo, '_id')
    ) {
      this.showAuthorizedUser = true;
    } else {
      this.showAuthorizedUser = false;
    }
  }

  navToUsersProfile() {
    if (this.userNavBlocked) {
      return;
    }
    this.tools.logAnalyticsEvent('trackCustom', 'nav-my-profile');
    const modal = this.modalCtrl.create('UserProfilePage', {
      user: this.user,
      user_id: this.user.info._id,
    });
    modal.present();
  }

  openDrawer() {
    this.tools.openDrawer();
  }

  closeSearch() {
    this.showButtons = false;
    this.loadingTabs = true;
    setTimeout(() => {
      this.loadingTabs = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/main-nav/main-nav.ts